import type { User, ApiResponse } from './types';

const API_BASE = import.meta.env.PROD
  ? 'https://novel-api.ruei2studio.com/api'
  : '/api';

export const authService = {
  getLoginUrl(): string {
    return `${API_BASE}/auth/login`;
  },

  async getCurrentUser(retried = false): Promise<User | null> {
    try {
      const response = await fetch(`${API_BASE}/auth/me`, {
        credentials: 'include',
      });

      if (!response.ok) {
        if (response.status === 401 && !retried) {
          const refreshed = await this.refresh();
          if (refreshed) {
            return this.getCurrentUser(true);
          }
        }
        return null;
      }

      const data: ApiResponse<User> = await response.json();
      return data.success ? data.data! : null;
    } catch {
      return null;
    }
  },

  async refresh(): Promise<boolean> {
    try {
      const response = await fetch(`${API_BASE}/auth/refresh`, {
        method: 'POST',
        credentials: 'include',
      });
      return response.ok;
    } catch {
      return false;
    }
  },

  async logout(): Promise<void> {
    try {
      await fetch(`${API_BASE}/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch {
      // Network error is fine — frontend state will still be cleared
    }
  },
};
